// extracted by mini-css-extract-plugin
export default {"span2Columns":"GnwGqZcRROuKBafpcLNF"};